import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { DataFieldPreSetOptionModel } from '@fi-app/data-field/data-field-pre-set-option.model';

@Component({
    selector: 'data-field-edit-custom-pre-set-options',
    template: `
        <div class="form-group full-width-material">
            <fi-select-search
                [items]="dropdownSettings.dataSet$ | async"
                [(ngModel)]="valuesModel"
                (ngModelChange)="valuesModelChange($event)"
                [label]="dataField.Name"
                [displayValue]="dropdownSettings.dataTextField"
                [matOptionValueProperty]="dropdownSettings.dataValueField"
                [filterBy]="dropdownSettings.filterBy"
                [required]="isSetRequired()"
                [isMultiSelect]="dataField.IsMultipleChoice"
                [errorText]="'common_error.mandatory' | fiAppText"
            >
            </fi-select-search>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'data-field-edit-custom-pre-set-options' },
    standalone: false,
})
export class DataFieldEditCustomPreSetOptionComponent extends DataFieldEditBase implements OnInit {
    dropdownSettings = new DropdownSettingsModelV2<DataFieldPreSetOptionModel>();
    valuesModel: number | number[];

    ngOnInit() {
        this.setDropdownSettings();
    }

    private setDropdownSettings() {
        this.dropdownSettings.setDataSet(this.dataField.PreSetOptions);
        this.valuesModel = this.dataField.IsMultipleChoice
            ? this.dataField.PreSetValues.map((item) => item.Id)
            : this.dataField.PreSetValues.length
              ? this.dataField.PreSetValues[0].Id
              : undefined;
    }

    valuesModelChange($event: number[] | number) {
        const selectedPresetValueIds: any = this.dataField.IsMultipleChoice ? $event : [$event];
        this.dataField.PreSetValues = this.dataField.PreSetOptions.filter((option: DataFieldPreSetOptionModel) => {
            return selectedPresetValueIds.indexOf(option.Id) > -1;
        });
    }
}
